import { createContext } from "react";

const GlobalContext = createContext({
    name: 'UU',
    firstName: 'U',
    lastName: 'U'
});

export default GlobalContext;